export default __webpack_public_path__ + "static/media/baosheng.1a4479d1.png";